var map = {
	"./_template.jsx": 387,
	"./docs/BasicToken.json": 1080,
	"./docs/BurnableToken.json": 1081,
	"./docs/Claimable.json": 1082,
	"./docs/ComplexExchanger.json": 1083,
	"./docs/ERC20.json": 1084,
	"./docs/ERC20Basic.json": 1085,
	"./docs/I_Exchanger.json": 1086,
	"./docs/I_Oracle.json": 1087,
	"./docs/LibreCash.json": 1088,
	"./docs/Math.json": 1089,
	"./docs/Migrations.json": 1090,
	"./docs/MintableToken.json": 1091,
	"./docs/Ownable.json": 1092,
	"./docs/SafeMath.json": 1093,
	"./docs/StandardToken.json": 1094,
	"./docs/_template.jsx": 1095,
	"./index.md": 1096
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1079;



//////////////////
// WEBPACK FOOTER
// . (coffee|cjsx|jsx|js|markdown|md|ipynb|html|json|yaml|toml)$
// module id = 1079
// module chunks = 0